/**
 * Filters the source meta into the targeting that is passed to the ad server
 * @access private
 */
export default (whitelist = [], metaData = {}) => {
  const targeting = {};

  const pageMeta = metaData.page;

  Object.keys(pageMeta).forEach((key) => {
    if (whitelist.includes(key)) {
      targeting[key] = pageMeta[key];
    }
  });

  return targeting;
};
